import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة عدد خطوات المشي اليومية لإنقاص الوزن بدقة";
const DESCRIPTION = "استخدم هذه الحاسبة لتحديد عدد الخطوات التي يجب عليك المشيها يوميًا لإنقاص وزنك بطريقة صحية وآمنة، بناءً على وزنك الحالي وهدفك في فقدان الوزن. مثالية للرجال والنساء المهتمين باللياقة البدنية.";
const KEYWORDS = "عدد خطوات المشي, إنقاص الوزن بالمشي, حاسبة الخطوات, خطوات لحرق الدهون, حرق السعرات بالمشي, جدول المشي اليومي, التخسيس بالمشي, فوائد المشي اليومي";
const OG_URL = "https://do-calculate.com/calculator/ar/walking-calories/";
function WalkingCalorieCalculator() {
  const [weight, setWeight] = useState("");
  const [sex, setSex] = useState("male");
  const [slope, setSlope] = useState("0");
  const [steps, setSteps] = useState("");
  const [distance, setDistance] = useState("");
  const [time, setTime] = useState({ hours: "", minutes: "" });
  const [speed, setSpeed] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const calculateCalories = () => {
    try {
      setError("");
      if (!weight) {
        throw new Error("الرجاء إدخال الوزن");
      }
      const weightKg = parseFloat(weight);
      const slopePercent = parseFloat(slope);
      const stepsCount = steps ? parseFloat(steps) : null;
      const distanceKm = distance ? parseFloat(distance) : null;
      const speedKmh = speed ? parseFloat(speed) : null;
      const hours = time.hours ? parseFloat(time.hours) : 0;
      const minutes = time.minutes ? parseFloat(time.minutes) : 0;
      if (weightKg <= 0) {
        throw new Error("يجب أن يكون الوزن أكبر من الصفر");
      }
      let calculatedDistance = distanceKm;
      let calculatedTime = hours + (minutes / 60);
      let calculatedSpeed = speedKmh;
      if (stepsCount && !distanceKm) {
        calculatedDistance = stepsCount * 0.762 / 1000;
      }
      if (calculatedDistance && calculatedTime && !speedKmh) {
        calculatedSpeed = calculatedDistance / calculatedTime;
      } else if (calculatedDistance && speedKmh && !calculatedTime) {
        calculatedTime = calculatedDistance / speedKmh;
      } else if (speedKmh && calculatedTime && !calculatedDistance) {
        calculatedDistance = speedKmh * calculatedTime;
      }
      let met;
      if (calculatedSpeed) {
        if (calculatedSpeed < 3.2) met = 2.0;
        else if (calculatedSpeed < 4.8) met = 2.8;
        else if (calculatedSpeed < 6.4) met = 3.5;
        else met = 5.0;
        met += Math.abs(slopePercent) * 0.1;
        if (slopePercent > 0) met *= 1.2;
        if (slopePercent < 0) met *= 0.8;
      } else {
        met = 3.5;
      }
      const caloriesBurned = met * weightKg * calculatedTime;
      const weightLost = caloriesBurned / 7700;
      setResult({
        caloriesBurned: caloriesBurned.toFixed(2),
        weightLost: weightLost.toFixed(4),
        distance: calculatedDistance ? calculatedDistance.toFixed(2) : null,
        time: calculatedTime.toFixed(2),
        speed: calculatedSpeed ? calculatedSpeed.toFixed(2) : null
      });
    } catch (error) {
      setError(error.message);
    }
  };
  const resetCalculator = () => {
    setWeight("");
    setSex("male");
    setSlope("0");
    setSteps("");
    setDistance("");
    setTime({ hours: "", minutes: "" });
    setSpeed("");
    setResult(null);
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  <strong>حاسبة عدد خطوات المشي لإنقاص الوزن</strong> تساعدك على معرفة عدد الخطوات المطلوبة يوميًا لتحقيق هدفك في فقدان الوزن بطريقة صحية.
                  تستند الحاسبة إلى وزنك، وسرعة المشي، والمسافة المقطوعة، وحتى انحدار السطح لتقديم تقدير دقيق للسعرات الحرارية المحروقة.
                </p>
                <p>
                  باستخدام هذه الأداة، يمكنك معرفة عدد الخطوات اللازم اتخاذها يوميًا لحرق الدهون بفعالية، سواء على جهاز المشي أو في الهواء الطلق.
                  تم تطوير الحاسبة بناءً على بيانات علمية لتناسب مختلف الأعمار والأوزان، وتمنحك رؤية واقعية لخطة المشي المثالية لك.
                </p>
                <p>
                  ستقوم الحاسبة بحساب السعرات الحرارية المحروقة والوزن المفقود بناءً على هذه البيانات.
                  التزم بـ150 دقيقة من النشاط أسبوعيًا كما توصي به الجهات الصحية، وابدأ اليوم برحلتك نحو وزن صحي بخطوات بسيطة ومدروسة.
                </p>
                <div>
                  المصادر:
                  <ul>
                    <li>
                      <a href="https://pubmed.ncbi.nlm.nih.gov/13932993/" target="_blank" rel="noopener noreferrer"> Energy cost of running</a>
                    </li>
                    <li>
                      <a href="https://pubmed.ncbi.nlm.nih.gov/31141585/" target="_blank" rel="noopener noreferrer">  Association of Step Volume and Intensity With All-Cause Mortality in Older Women</a>
                    </li>
                  </ul>
                </div>
                <hr />
              </div>
              <br />
              <MobileUnderCalAds/>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="weight">
                        الوزن (كجم)
                      </label>
                      <input
                        id="weight"
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="أدخل وزنك"
                        className="form-control"
                        style={{ width: "75%" }}
                        min="1"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="sex">
                        الجنس
                      </label>
                      <select
                        id="sex"
                        value={sex}
                        onChange={(e) => setSex(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="male">ذكر</option>
                        <option value="female">أنثى</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="slope">
                        ميل سطح المشي (%)
                      </label>
                      <input
                        id="slope"
                        type="number"
                        value={slope}
                        onChange={(e) => setSlope(e.target.value)}
                        placeholder="أدخل نسبة الميل"
                        className="form-control"
                        style={{ width: "75%" }}
                        min="-30"
                        max="30"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="steps">
                        الخطوات
                      </label>
                      <input
                        id="steps"
                        type="number"
                        value={steps}
                        onChange={(e) => setSteps(e.target.value)}
                        placeholder="أدخل عدد الخطوات"
                        className="form-control"
                        style={{ width: "75%" }}
                        min="0"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        وقت المشي (ساعات:دقائق)
                      </label>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <input
                          type="number"
                          value={time.hours}
                          onChange={(e) => setTime({ ...time, hours: e.target.value })}
                          placeholder="ساعات"
                          className="form-control"
                          style={{ width: '35%' }}
                          min="0"
                        />
                        <input
                          type="number"
                          value={time.minutes}
                          onChange={(e) => setTime({ ...time, minutes: e.target.value })}
                          placeholder="دقائق"
                          className="form-control"
                          style={{ width: '35%' }}
                          min="0"
                          max="59"
                        />
                      </div>
                    </div>
                    <br />
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button
                        className="btn btn-success"
                        style={{ fontSize: "20px" }}
                        onClick={calculateCalories}
                      >
                        احسب                      </button>
                      <button
                        className="text-white bg-secondary"
                        style={{ fontSize: "20px" }}
                        onClick={resetCalculator}
                      >
                        مسح
                      </button>
                    </div>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتائج:</h4>
                      <p className="text-white">السعرات الحرارية المحروقة: {result.caloriesBurned} سعرة حرارية</p>
                      <p className="text-white">الوزن المفقود: {result.weightLost} كجم</p>
                      {result.distance && (
                        <p className="text-white">المسافة المقطوعة: {result.distance} كم</p>
                      )}
                      {result.speed && (
                        <p className="text-white">سرعة المشي: {result.speed} كم/ساعة</p>
                      )}
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">حاسبة السعرات الحرارية للمشي</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>فوائد المشي</h2>
                  </u>
                  <p>المشي هو أحد أكثر أشكال النشاط البدني سهولة ولكنه الأكثر استخفافًا به. على الرغم من أن فكرة 10,000 خطوة يوميًا قد تكون مبالغًا فيها للبعض، إلا أن المشي 7,000-8,000 خطوة يوميًا له فوائد صحية عديدة!</p>
                  <ul>
                    <li>وفقًا لدراسة 2019، يمكن لـ 4,400 خطوة يوميًا أن تقلل بشكل كبير من معدلات الوفيات</li>
                    <li>يساعد المشي في الوقاية من أمراض القلب والأوعية الدموية</li>
                    <li>أداة مساعدة أساسية في التعامل مع مرض السكري</li>
                    <li>يقلل من القلق ويحسن الصحة العقلية</li>
                    <li>يحسن التحمل والقوة العضلية على المدى الطويل</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info">
                    المشي لمدة 30 دقيقة يوميًا يمكن أن يحرق حوالي 150-200 سعرة حرارية!
                  </div>
                  <br />
                  <p>
                    تفيد تقارير NHS أن المشي يمكن أن يساعدك على "بناء القدرة على التحمل وحرق السعرات الحرارية الزائدة وجعل قلبك أكثر صحة".
                    ومع ذلك، لا يمكنك مجرد المشي قليلا إلى متجرك المحلي وتوقع فقدان الوزن.
                    إذا كان حرق السعرات الحرارية هو هدفك، فقد تساعدك أداة جديدة في تقدير عدد الخطوات التي يتعين عليك اتخاذها لإنقاص الوزن.
                  </p>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيفية استخدام الحاسبة</h2>
                  </u>
                  <p>حاسبة السعرات الحرارية للمشي من موقع احسب تساعدك على تقدير السعرات الحرارية التي تحرقها أثناء المشي:</p>
                  <ol>
                    <li>أدخل وزنك الحالي</li>
                    <li>أدخل ميل سطح المشي (إيجابي للمنحدرات الصعودية، سلبي للهبوط)</li>
                    <li>أدخل إما المسافة المقطوعة أو الوقت أو السرعة المتوسطة</li>
                  </ol>
                  <p>ستقوم الحاسبة بحساب السعرات الحرارية المحروقة والوزن المفقود بناءً على هذه البيانات.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    يمكنك استخدام هذه الحاسبة للمشي العادي أو على جهاز المشي!
                  </div>
                  <br />
                  <p>
                    غالبا ما يتم التغاضي عن المشي كشكل من أشكال التمارين الرياضية، إلا أن هذا النوع من التمارين السهلة والمجانية والمنخفضة التأثير يمكن أن يساعدك على التخلص من بعض الكيلوغرامات.
                  </p>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>أسئلة شائعة</h2>
                  </u>
                  <p><b>كم عدد السعرات الحرارية التي يحرقها المشي 10,000 خطوة؟</b></p>
                  <p>في المتوسط، يحرق الرجل حوالي 500 سعرة حرارية بينما تحرق المرأة حوالي 290 سعرة حرارية.</p>
                  <p><b>هل من الضروري المشي 10,000 خطوة يوميًا؟</b></p>
                  <p>لا، لكن 7,500-8,000 خطوة يوميًا توفر فوائد صحية جيدة.</p>
                  <p><b>هل للمشي حافي القدمين فوائد صحية؟</b></p>
                  <p>نعم، فهو يقوي عضلات القدمين والساقين ويحسن التوازن.</p>
                  <p><b>كم عدد السعرات الحرارية التي أحرقها عند المشي لمدة ساعة؟</b></p>
                  <p>يتراوح ما بين 200-500 سعرة حرارية حسب الوزن والسرعة والميل.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    تذكر أن المشي الجماعي مع الأصدقاء أو العائلة يجعل النشاط أكثر متعة!
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WalkingCalorieCalculator;